import type {ReactElement, ReactNode} from 'react';
import {AiChatMobileNav} from '@AiChat/components/ai-chat-mobile-nav/ai-chat-mobile-nav';
import {AiChatNav} from '@AiChat/components/ai-chat-nav/ai-chat-nav';
import {AiChatSidebar} from '@AiChat/components/ai-chat-sidebar/ai-chat-sidebar';
import {AiChatConversation} from '@AiChat/components/ai-chat-conversation/ai-chat-conversation';
import {AiChatEmptyStateContent} from '@AiChat/components/ai-chat-empty-state-content/ai-chat-empty-state-content';
import {AiChatFooter} from '@AiChat/components/ai-chat-footer/ai-chat-footer';
import {useAiChatLayout} from '@AiChat/hooks/useAiChatLayout';
import {AiChatSeasonalPageDecorations} from '@AiChat/components/ai-chat-seasonal-page-decorations/ai-chat-seasonal-page-decorations';
import type {AiChatPageContentProps} from './ai-chat-page-content.types';

export function AiChatPageContent({chatOnLoadParams, className, conversationClassName}: AiChatPageContentProps): ReactElement {
  const {isMobileLayout, showsSidebarRail} = useAiChatLayout();

  const renderNavigationBar = (): ReactElement => {
    if (isMobileLayout) {
      return <AiChatMobileNav />;
    }

    return <AiChatNav />;
  };

  const renderSidebarRail = (): ReactNode => {
    if (!showsSidebarRail) {
      return null;
    }

    return <AiChatSidebar />;
  };

  return (
    <div className={className}>
      <AiChatSeasonalPageDecorations />
      {renderNavigationBar()}
      {renderSidebarRail()}
      <AiChatConversation chatOnLoadParams={chatOnLoadParams} className={conversationClassName}>
        <AiChatEmptyStateContent />
        <AiChatFooter />
      </AiChatConversation>
    </div>
  );
}
